import { Box, IconButton, Tooltip, Typography } from "@mui/material"
import { Dispatch, SetStateAction, useMemo, useState } from "react"
import { icons } from "../../../../../../../utils/icons"
import { useTranslation } from "react-i18next"
import CustomAccordion from "../../../../../../../components/accordion"
import { CaptionKeyVertical } from "../../../../../../../components/detailKeyValue/keyCaption.index"
import StatusComponent from "../../../../../../../components/status"
import { ChildrenCoordinates } from "../activityOnMap/types"
import { useStyles } from "./styles"
import { getStatus } from "../../../../../../../hooks/status"
import { useContextState } from "../../../../../../../hooks/theme"
import { Status } from "../../../../../../../utils/enums"
import { getType } from "../../../utils/methods/getTypeActivity"


const AcordionActivityMap = ({ child }: { child: ChildrenCoordinates }) => {

    const styles = useStyles()
    const { t } = useTranslation()
    const { colors } = useContextState()
    const { title, endDate, endExecution, isForcedClosure, startDate, startExecution, typeProgramation, status, userAssigned } = child

    const statusDetail = useMemo(() => getStatus(status as Status, colors, t), [status])
    const isNoFinisf = status === Status.NOT_FINISHED ? true : false;
    const colorNoFinish = colors.color13
    const [expanded, setExpanded] = useState(false)

    return (


        <CustomAccordion
            title={(
                <Box sx={styles.acordionTitleContainerArrow(expanded)}>
                    <Box sx={styles.acordionTitleContainer}>
                        <Typography variant="text_grey" fontWeight='bold' fontSize={16}>{title ?? ''}</Typography>
                        <Box sx={styles.acordionTitleDescription}>
                            <Box sx={styles.containerKey}>
                                <CaptionKeyVertical captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }}  caption={`${t('general.assignedUser')}: `} value={userAssigned || 'N/A'} />
                            </Box>

                            <StatusComponent color={isNoFinisf ? colorNoFinish : statusDetail.color} msg={statusDetail.text} type="chip" size="xs" fit />
                        </Box>
                    </Box>

                    <Tooltip title={t(`ToolTips.${expanded ? 'collapse' : 'expand'}`)}>
                        <IconButton
                            onClick={(e) => {
                                e.stopPropagation();
                                setExpanded(prev=> !prev);
                            }}
                            sx={[styles.arrow, styles.rotate(expanded)]}
                        >{icons('arrow-down')} </IconButton>
                    </Tooltip>
                </Box>
            )}
            description={
                <Box sx={styles.flex}>
                    <Box sx={styles.flex}>
                        {/* <Typography variant="text_grey" fontWeight='bold' fontSize={16}>{title ?? ''}</Typography> */}
                        {/* <CaptionKeyVertical captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }} caption={`${t('loogbook.titles.title')}: `} value={title ?? 'N/A'} /> */}
                        <CaptionKeyVertical captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }} caption={`${t('loogbook.programationType')}: `} value={getType(typeProgramation, t)} />
                        {startDate && <CaptionKeyVertical captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }} caption={`${t('loogbook.titles.startDate')}: `} value={startDate || 'N/A'} />}
                        {endDate && <CaptionKeyVertical captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }} caption={`${t('loogbook.titles.endDate')}: `} value={endDate || 'N/A'} />}
                    </Box>

                    {startExecution && <Box sx={styles.flex}>
                        <Typography sx={styles.titles} variant="text_grey" fontWeight='bold' fontSize={16}>{t('loogbook.titles.execution')}</Typography>
                        {endExecution && <CaptionKeyVertical captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }} caption={`${t('loogbook.titles.closeType')}: `} value={isForcedClosure ? <Typography sx={styles.error} variant="text_grey" fontWeight='500'>{icons('info')}{t('loogbook.titles.forced')}</Typography> : <Typography variant="text_grey" fontWeight='500'>{t('loogbook.titles.normal')}</Typography>} />}
                        {startExecution && <CaptionKeyVertical captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }} caption={`${t('loogbook.titles.startDate')}: `} value={startExecution || 'N/A'} />}
                        {endExecution && <CaptionKeyVertical captionProps={{ sx: { width: '49%' } }} valueProps={{ sx: { width: '49%' } }} caption={`${t('loogbook.titles.endDate')}: `} value={endExecution || 'N/A'} />}
                    </Box>}

                </Box>
            }
            expandIcon={null}
            expanded={expanded}
        />

    )
}

export { AcordionActivityMap }